// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_Eh5","cls2":"ImpactHubModal-cls2__qA ImpactHubModal-cls1_Eh5"};